var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Setup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h11.66a12.8 12.8 0 00-23.37-1H13.23a6.06 6.06 0 00-6 6.08 5.93 5.93 0 006 5.92H46.6a12.8 12.8 0 0022.81-1H58V15zm-44.71 7a2 2 0 110-4 2 2 0 010 4zM42.8 49L37 59l5.8 10h11.55l5.77-10-5.77-10H42.8zM52 65h-6.89l-3.47-6 3.47-6H52l3.46 6L52 65zm-1.47-6a2 2 0 11-2-2 2.001 2.001 0 012.04 2h-.04zM33.2 32H21.65l-5.77 10 5.77 10H33.2L39 42l-5.8-10zm-2.31 16H24l-3.5-6 3.5-6h6.93l3.47 6-3.51 6zm-1.46-6a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Setup.f2695b8f.svg";
export { SvgJ2Setup as ReactComponent };